import { gql } from "@apollo/client"

export const DeleteBrand = gql`
mutation DeleteBrand($deleteBrandId: ID!) {
  deleteBrand(id: $deleteBrandId) {
    status
  }
}
`